export default __webpack_public_path__ + "static/media/collapsible-app-bar-dynamic.0dab9b15.gif";